var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CrudTable',_vm._b({attrs:{"storeModule":_vm.storeModule,"addItems":false},scopedSlots:_vm._u([{key:_vm.linkAttributes.path,fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'JunoProductDetail', params: { id: item.id }}}},[_vm._v(" "+_vm._s(_vm.Lget(item, _vm.linkAttributes.name, '-') || '-')+" ")])]}}],null,true)},'CrudTable',_vm.crudTableConfig,false))}
var staticRenderFns = []

export { render, staticRenderFns }